import Vue from 'vue';
import { guid } from '@/mixins/guid';
import { uploader } from '@/mixins/aws/uploader/s3';
import uploadProgress from '@/mixins/aws/uploader';
import tooltip from '@/mixins/components/tooltip';
import path from 'path';
import _ from 'lodash';
import { CUSTOM_DIVIDER } from '@/constants';

export default Vue.component('shape-divider-custom-upload', {
  template: require('./template.html'),
  mixins: [guid, uploader],
  components: {
    uploadProgress,
    tooltip,
  },
  computed: {
    displayName() {
      return path.basename(this.display.file);
    },
  },
  data() {
    return {
      loading: false,
      display: {
        file: CUSTOM_DIVIDER,
      },
      prefix: 'drz_section_divider_',
      bucketPath: '_droplet-assets/sectionDividers/',
      thumbnails: '_droplet-assets/_thumbnails/sectionDividers/',
      dividerFiles: [],
      showConfirm: false,
      activeImage: null,
      showFiles: false,
      hoverDel: false,
      activeIndex: null,
      uploading: false,
    };
  },
  name: 'shape-divider-custom-upload',
  props: ['divider-coords'],
  created() {
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      this.display.file = this.dividerCoords.customFile || CUSTOM_DIVIDER;
    },
    matchFile(file) {
      const f = file.split('/').pop();
      const media = this.display.file.split('/').pop();
      return f === media;
    },
    toggleBrowse() {
      this.showFiles = !this.showFiles;
      if (this.showFiles) {
        this.fetchDividerFiles();
      }
    },
    openUpload() {
      this.$refs.uploadFile.click();
    },
    async uploadCustom(e) {
      this.$validator.validateAll().then(async (result) => {
        // run only if file types and dimensions are correct
        if (result) {
          let newFile = [...e.target.files];
          if (newFile.length > 0) {
            this.uploading = true;
            newFile = newFile[0];
            // clean up the file name for s3
            let fileName = path.basename(newFile.name);
            fileName = `${this.prefix}${_.trim(fileName)}`;
            fileName = _.replace(fileName, /\s+/g, '_');

            try {
              // send off to our s3 upload mixin
              const filePath = `/${this.bucketPath}${fileName}`;
              await this.uploadFile({
                file: `${this._sitePath}${filePath}`,
                body: newFile,
                thumbnail: {
                  width: 35,
                  srcFile: newFile,
                  name: fileName,
                  bucketPath: `${this._sitePath}/${this.thumbnails}`,
                },
              });
              await this.updateCustomSrc(filePath);
            } catch (err) {
              if (!err.message.match(/aborted/gi)) {
                this.$log.error(err);
                await this._reportError({
                  error: err,
                  fn: 'uploadCustom',
                });
              }
            } finally {
              if (this.showFiles) {
                this.fetchDividerFiles();
              }
              this.uploading = false;
            }
          }
          // reset value to null so we can get the "change" event to run
          // in any case. Even when the user selects the same file
          e.target.value = null;
        }
      });
    },
    async fetchDividerFiles() {
      try {
        this.loading = true;
        const assetsFolder = '/_droplet-assets';
        const files = await this._s3fetchFiles(`${this._sitePath}/${this.thumbnails}`);
        this.dividerFiles = files.map(f => `${assetsFolder}${f.split(assetsFolder)[1]}`);
      } catch (err) {
        this.showFiles = false;
        await this._reportError({
          error: err,
          fn: 'fetchDividerFiles',
        });
      } finally {
        this.loading = false;
      }
    },
    matchBg(image) {
      const currentFile = path.basename(this.display.file);
      const img = this._getFromThumb(path.basename(image));
      return img === currentFile;
    },
    confirmDelete(file) {
      this.activeImage = file;
      this.toggleConfirm();
    },
    toggleConfirm() {
      this.showConfirm = !this.showConfirm;
    },
    async deleteCustomFile() {
      // prep notifcation type
      const notif = {
        id: this.guid(),
      };
      const file = path.basename(this._getFromThumb(this.activeImage));
      const thumb = path.basename(this.activeImage);
      try {
        this.loading = true;
        // delete original from s3
        await this._s3deleteFile({
          key: `${this._fullSiteFolder}/${this.bucketPath}${file}`,
        });
        // delete thumbnail from s3
        await this._s3deleteFile({
          key: `${this._fullSiteFolder}/${this.thumbnails}${thumb}`,
        });
        // set for notifications
        notif.type = 'success';
        notif.message = `Successfully deleted image file: ${file}`;
      } catch (err) {
        // set for notifications
        notif.type = 'error';
        notif.message = `${err.message || err}. This has been reported.`;
        await this._reportError({
          error: err,
          fn: 'deleteCustomFile',
        });
      } finally {
        // send off to notifications
        this.$store.dispatch('addNotification', notif);
        // kill loader & refetch files
        this.loading = false;
        this.showConfirm = false;
        this.fetchDividerFiles();
      }
      // if deleting image that is being used, reset it to default
      if (this.display.file === `/${this.bucketPath}${file}`) {
        this.updateCustomSrc(CUSTOM_DIVIDER, true);
      }
    },
    async updateCustomSrc(f, def) {
      // if came from click, gather full url
      let file;
      if (def) {
        file = f;
      } else {
        file = `/${this.bucketPath}${this._getFromThumb(path.basename(f))}`;
      }
      this.$store.dispatch('setDropletVal', {
        drp: this.dividerCoords,
        key: 'customFile',
        val: file,
      });
      this.display.file = file;
    },
    formatErrors(ers) {
      return ers.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/style-sidebar/options/section-options/shape-dividers/custom/index.js